export default {
    MESSAGING: 'in-app-messaging',
    NETWORK_MATCH_ENHANCEMENT: 'network-match-enhancement',
    ACCOUNTING_REPORTS: 'accounting-reports'
};
